import React, { useState } from 'react';
import { Settings, Close, CheckCircle } from '@mui/icons-material';
import { usePaymentPlatform } from '../context/PaymentPlatformContext';

const DebugMenu = () => {
  const {
    paymentPlatform,
    switchPaymentPlatform,
    availablePlatforms,
    isDebugMode,
    currentPlatform
  } = usePaymentPlatform();

  const [isOpen, setIsOpen] = useState(false);

  if (!isDebugMode) return null;

  return (
    <>
      {/* Debug Menu Toggle Button */}
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          position: 'fixed',
          top: 35,
          right: 65,
          zIndex: 9999,
          backgroundColor: '#f44336',
          color: 'white',
          width: 30,
          height: 30,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
          border: '2px solid #fff',
          transition: 'all 0.3s ease'
        }}
      >
        {isOpen ? <Close /> : <Settings />}
      </div>

      {/* Debug Menu Panel */}
      {isOpen && (
        <div style={{
          position: 'fixed',
          top: 80,
          right: 20,
          zIndex: 9998,
          backgroundColor: 'white',
          border: '1px solid #ddd',
          borderRadius: 8,
          boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
          padding: 20,
          minWidth: 300,
          maxWidth: 400
        }}>
          <div style={{ marginBottom: 16 }}>
            <h3 style={{
              margin: '0 0 8px 0',
              fontSize: 16,
              fontWeight: 'bold',
              color: '#f44336'
            }}>
              🚧 Debug Mode
            </h3>
            <p style={{
              margin: 0,
              fontSize: 14,
              color: '#666',
              lineHeight: 1.4
            }}>
              Payment platform selection for testing. Only visible in non-production environments.
            </p>
          </div>

          <div style={{ marginBottom: 16 }}>
            <div style={{
              fontSize: 14,
              fontWeight: 'bold',
              marginBottom: 8,
              color: '#333'
            }}>
              Current Platform: {currentPlatform?.name}
            </div>
            <div style={{
              fontSize: 12,
              color: '#666',
              backgroundColor: '#f5f5f5',
              padding: 8,
              borderRadius: 4,
              marginBottom: 12
            }}>
              {currentPlatform?.description}
            </div>
          </div>

          <div>
            <div style={{
              fontSize: 14,
              fontWeight: 'bold',
              marginBottom: 12,
              color: '#333'
            }}>
              Available Platforms:
            </div>

            {availablePlatforms.map((platform) => (
              <div
                key={platform.id}
                onClick={() => switchPaymentPlatform(platform.id)}
                style={{
                  padding: 12,
                  marginBottom: 8,
                  border: paymentPlatform === platform.id ? '2px solid #3b72fe' : '1px solid #ddd',
                  borderRadius: 6,
                  cursor: 'pointer',
                  backgroundColor: paymentPlatform === platform.id ? '#f0f4ff' : 'white',
                  transition: 'all 0.2s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <div>
                  <div style={{
                    fontWeight: 'bold',
                    fontSize: 14,
                    color: paymentPlatform === platform.id ? '#3b72fe' : '#333'
                  }}>
                    {platform.name}
                  </div>
                  <div style={{
                    fontSize: 12,
                    color: '#666',
                    marginTop: 2
                  }}>
                    {platform.description}
                  </div>
                </div>

                {paymentPlatform === platform.id && (
                  <CheckCircle style={{
                    color: '#3b72fe',
                    fontSize: 20
                  }} />
                )}
              </div>
            ))}
          </div>

          <div style={{
            marginTop: 16,
            padding: 12,
            backgroundColor: '#fff3cd',
            border: '1px solid #ffeaa7',
            borderRadius: 4,
            fontSize: 12,
            color: '#856404'
          }}>
            <strong>Note:</strong> Changes persist in localStorage for this session. Refresh the page after switching platforms for full effect.
          </div>
        </div>
      )}
    </>
  );
};

export default DebugMenu;
